// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"8b600499","417":"26065adf","466":"957072cf","545":"6926921a"}[chunkId] + ".chunk.css";
};